import 'css-chunksrc/client/pages/projectPage/wbsPage/statuses/tasks/task/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_1mzfz_1",
  "form": "_form_1mzfz_6",
  "name": "_name_1mzfz_1",
  "icon": "_icon_1mzfz_23",
  "input": "_input_1mzfz_27",
  "late": "_late_1mzfz_48",
  "edition": "_edition_1mzfz_52"
};